import { render, staticRenderFns } from "./CrudPersonalityDetails.vue?vue&type=template&id=52406fa9&scoped=true"
import script from "./CrudPersonalityDetails.vue?vue&type=script&lang=ts"
export * from "./CrudPersonalityDetails.vue?vue&type=script&lang=ts"
import style0 from "./CrudPersonalityDetails.vue?vue&type=style&index=0&id=52406fa9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52406fa9",
  null
  
)

export default component.exports